import "./styles.less";

import React, { FC, useContext } from "react";

import { Col, Row, Skeleton, Space, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { IconFacility } from "./IconFacility/web";

import { useTheme } from "../../../Styles/ThemeHook";
import { FacilitiesProps, useFacilities } from "./Facilities.hook";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";

export const Facilities: FC<FacilitiesProps> = ({
	mode = "auto",
	facilities = [],
	loading = false,
	isEspecial,
}) => {
	const { facilitiesList } = useFacilities(facilities);
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);

	if (!facilitiesList || facilitiesList.length == 0) {
		return null;
	}

	const titleText = mode === "project" ? "Amenities" : "Comodidades de la propiedad";

	return (
		<Row gutter={[0, theme.spacing.lgSpacing]} className="property-facilities">
			<Col span={24} key="property_facilities">
				<Typography.Title level={4}>{titleText}</Typography.Title>
				{loading ? (
					<Skeleton active />
				) : (
					<Row gutter={[theme.spacing.lgSpacing, theme.spacing.xsSpacing]}>
						{facilitiesList.map((o, i) => (
							<Col
								span={isEspecial ? 24 : null}
								sm={isEspecial ? 12 : null}
								style={isEspecial ? { marginBottom: ".625rem" } : null}
								key={"property_facility_" + i}
							>
								<Space size={5} className={`${country_code}-facility-batch`}>
									{country_code !== "ce3" && (
										<Typography.Text type={"secondary"} className="small">
											{isEspecial ? (
												<CheckOutlined
													style={{ color: "#0ec6d5", marginRight: 8 }}
												/>
											) : (
												"•"
											)}
										</Typography.Text>
									)}
									{country_code === "ce3" && <IconFacility id={o.id} />}
									<Typography.Text>{o.name}</Typography.Text>
								</Space>
							</Col>
						))}
					</Row>
				)}
			</Col>
		</Row>
	);
};
